// Links to product details page based on product kind
export enum GroundLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-ground-photo',
  FR = 'https://bkbn.com/fr/portfolio/photo-immobiliere-prise-au-sol',
  DE = 'https://bkbn.com/de/portfolio/immobilien-bodenfoto',
}

export enum DroneLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-drone-photo',
  FR = 'https://bkbn.com/fr/portfolio/photo-immobiliere-drone',
  DE = 'https://bkbn.com/de/portfolio/immobilien-drohnenfoto',
}

export enum PrestigeLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-prestige-photo',
  FR = 'https://bkbn.com/fr/portfolio/photo-immobiliere-prestige',
  DE = 'https://bkbn.com/de/portfolio/immobilien-prestigefoto',
}

export enum GroundVideoLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-ground-video',
  FR = 'https://bkbn.com/fr/portfolio/video-immobiliere-au-sol',
  DE = 'https://bkbn.com/de/portfolio/immobilien-boden-video',
}

export enum GroundDroneVideoLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-ground-and-drone-video',
  FR = 'https://bkbn.com/fr/portfolio/video-immobiliere-sol-et-drone',
  DE = 'https://bkbn.com/de/portfolio/immobilien-video-boden-und-drohne',
}

export enum DroneVideoLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-drone-video',
  FR = 'https://bkbn.com/fr/portfolio/video-immobiliere-drone',
  DE = 'https://bkbn.com/de/portfolio/immobilien-drohnen-video',
}

export enum TeaserVideoLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-teaser-video',
  FR = 'https://bkbn.com/fr/portfolio/video-immobiliere-teaser',
  DE = 'https://bkbn.com/de/portfolio/immobilien-teaser-video',
}

export enum PrestigeVideoLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-prestige-video',
  FR = 'https://bkbn.com/fr/portfolio/video-immobiliere-prestige',
  DE = 'https://bkbn.com/de/portfolio/immobilien-prestige-video',
}

export enum PhotoExtractionLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-photo-extraction',
  FR = 'https://bkbn.com/fr/portfolio/extraction-photo-immobiliere',
  DE = 'https://bkbn.com/de/portfolio/immobilienfoto-extraktion',
}

export enum HightDefinitionTourLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-high-definition-tour',
  FR = 'https://bkbn.com/fr/portfolio/visite-virtuelle-haute-definition-immobiliere',
  DE = 'https://bkbn.com/de/portfolio/immobilien-hd-tour',
}

export enum StandardStagingLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-standard-staging',
  FR = 'https://bkbn.com/fr/portfolio/staging-virtuel-standard-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-standard-staging',
}

export enum Staging360Links {
  EN = 'https://bkbn.com/portfolio/real-estate-360-staging',
  FR = 'https://bkbn.com/fr/portfolio/staging-360-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-360-staging',
}

export enum ResidentialRenderingLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-residential-rendering',
  FR = 'https://bkbn.com/fr/portfolio/rendering-residentiel-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-wohnungsrendering',
}

export enum CommercialRenderingLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-commercial-rendering',
  FR = 'https://bkbn.com/fr/portfolio/rendering-commercial-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-gewerberaum-rendering',
}

export enum Rendering360Links {
  EN = 'https://bkbn.com/portfolio/real-estate-360-rendering',
  FR = 'https://bkbn.com/fr/portfolio/rendering-360-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-360-rendering',
}

export enum SlideshowLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-slideshow',
}

export enum FloorPlanCaptureLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-floor-plan-capture',
  FR = 'https://bkbn.com/fr/portfolio/capture-de-plan-de-sol-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-grundrissaufnahme',
}

export enum MatterportFloorPlanLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-matterport-floor',
  FR = 'https://bkbn.com/fr/portfolio/plan-de-sol-matterport-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-matterport-grundrisse',
}

export enum FloorPlan3DLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-3d-floor-plan',
  FR = 'https://bkbn.com/fr/portfolio/plan-de-sol-3d-immobilier',
  DE = 'https://bkbn.com/de/portfolio/immobilien-3d-grundriss',
}

export enum MeasurementOnSiteLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-on-site-area-report',
  DE = 'https://bkbn.com/de/portfolio/immobilien-aufmass-vor-ort',
}

export enum ConstructionFilesLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-bauakte',
  DE = 'https://bkbn.com/de/portfolio/immobilien-bauakte',
}

export enum LandRegisterLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-land-register',
  DE = 'https://bkbn.com/de/portfolio/immobilien-grundbuchauszug',
  FR = 'https://bkbn.com/fr/portfolio/registre-foncier-immobilier',
  ES = 'https://bkbn.com/es/portfolio/registro-propiedad-inmueble',
  NL = 'https://bkbn.com/nl/portfolio/kadaster-uittreksel-vastgoed',
}

export enum ProtectionLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-protection',
  DE = 'https://bkbn.com/de/portfolio/immobilien-belastungen',
}

export enum MunicipalLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-municipal',
  DE = 'https://bkbn.com/de/portfolio/immobilien-kommunalabgaben',
}

export enum DocumentationLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-documentation',
  DE = 'https://bkbn.com/de/portfolio/immobilien-steuerliche-bescheide-gesellschaftsunterlagen',
}

export enum LawInquiriesLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-law-inquiries',
  DE = 'https://bkbn.com/de/portfolio/immobilien-planungsrechtsauskuenfte',
}

export enum EnergyCertificateLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-energy-certificate',
  DE = 'https://bkbn.com/de/portfolio/immobilien-energieausweis',
}

export enum FloorPlanCertificateLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-living-area-calculation',
  DE = 'https://bkbn.com/de/portfolio/immobilien-wohnflaechenberechnung',
}

export enum BlurringLinks {
  EN = 'https://bkbn.com/portfolio/real-estate-extended-blur',
  DE = 'https://bkbn.com/de/portfolio/immobilien-erweiterte-unschaerfe',
  FR = 'https://bkbn.com/fr/portfolio/floutage-complet-immobilier',
}

/**
 * Fragment appended to the product details page of a single catalogue product, keyed by product id.
 *
 * Several products share one details page - without a fragment the page opens at the top, on a
 * different product's section. Only sections that exist in every locale of the page belong here.
 */
export const PRODUCT_DETAILS_PAGE_SECTIONS: Record<number, string> = {
  4254: 'teilungserklaerung', // Teilungserklärung
  4255: 'teilungserklaerung', // Teilungserklärung vor Ort inkl. Aufteilungsplan
}
